<template>
  <section id="beltroad">
    <v-container inner>
      <div class="intro-article mt-5">
        <p class="body-2 mb-4">
          Back in September 2013, President Xi Jinping first introduced the Silk Road Economic Belt during his visit to Kazakhstan. Just a month later, he gave another speech to the Indonesian parliament and proposed the 21st Century Maritime Silk Road.
        </p>

        <p class="body-2 mb-4">
          Together, these two features are now dubbed the Belt, Road Initiative (or sometimes, One Belt, One Road).
        </p>

        <p class="body-2 mb-4">
          Both initiatives aim at creating trade habitats across the globe that will cultivate multilateral economic cooperation and connectivity. In order to do so, infrastructure is key. To this, China is investing all across the globe mainly in transport and energy.
        </p>
      </div>

      <div class="intro-beltroad mt-5">
        <h2 class="headline font-secondary mb-4">What is Belt? What is Road?</h2>

        <p class="body-2">
          The Silk Road Economic Belt draws on the grandeur of the historic Silk Road trade that spanned from the 2nd century BC to the 15th century. It retraces the connections that joined Asia and Eurasia. Likewise, the 21st Century Maritime Silk Road is meant to revive the maritime silk road, which connected continents for 17 centuries. Contrary to its name, the maritime route was focused on something else—spice.
        </p>

        <p class="body-2">
          Despite its mandarin name「一帶一路」, the Belt and Road are not really one and singular. The Belt comprises of six economic corridors that connect China with Europe via Central Asia, Russia, and the Middle East. The Road comprises of three <a href="http://www.chinadaily.com.cn/business/2017-06/21/content_29825517.htm" target="_blank">Blue Economic Passages</a> that join Asia with Africa, Europe, and Oceania.
        </p>
      </div>
    </v-container>

    <!-- map -->
    <MapCorridors />

    <v-container inner py-0>
      <span class="caption font-italic">Click any line to see more information about the corridors</span>
    </v-container>
  </section>
</template>

<script>
// components
import MapCorridors from '@/components/controllers/MapCorridors.vue';

export default {
  name: 'SectionBeltRoad',
  components: {
    MapCorridors,
  },
};
</script>
